import { getDateString } from "common/date-utils";
const formatDateItem = (val) => {
    const date = val instanceof Date ? val : new Date(val);
    return getDateString(date) ?? String(val);
};
const buildPopupContent = (items) => {
    const listItems = items.map((item) => `<li>${item}</li>`).join("");
    return `<ul class="multi-value-popup-list">${listItems}</ul>`;
};
export const buildMultiValuePopupData = (rawItems, title, dataType) => {
    if (!rawItems?.length) {
        return undefined;
    }
    const items = dataType === "date"
        ? rawItems.map((val) => formatDateItem(val))
        : rawItems.map(String);
    if (items.length === 1) {
        return {
            exportItems: items,
            label: items[0],
            linkLabel: null,
            popupContent: null
        };
    }
    const popupContent = buildPopupContent(items);
    const remainingCount = items.length - 1;
    return {
        exportItems: items,
        header: `${items.length} ${title}s`,
        isHover: false,
        label: `${items[0]} +${remainingCount}`,
        linkLabel: `+${remainingCount}`,
        popupContent,
        textLabel: items[0]
    };
};
